import { Box, Heading, Text, VStack, Divider } from '@chakra-ui/react';
import { useEffect } from 'react';

export default function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <VStack p={[5, 10, 20]} spacing={8} align="start" maxW="1200px" mx="auto">
        <Heading color="#0C727E" size="2xl">Terms of Use</Heading>
        
        <VStack align="start" spacing={4}>
          <Text fontSize="lg">
            Dilate Laboratory is engaged in providing diagnostic services to the patient through the digital network of its associated diagnostic centers. These services are provided through our website, app, or phone as the case may be.
          </Text>
          <Text>
            A user, by using our services, consents to our privacy policy, terms of use, and disclaimer as presented on www.dilatelabs.com. The services provided by Dilate Labs are in the nature of aggregation with technology intermediation.
          </Text>
        </VStack>

        <Divider />

        <VStack align="start" spacing={4}>
          <Heading size="md" color="teal.700">Medical Disclaimer</Heading>
          <Text>
            We are not providing any medical assessment or advice whatsoever. Though we take all precautions to ensure that only high-quality diagnostic labs are allowed to tie-up with us, Dilate Laboratory does not take any responsibility for the accuracy and quality of the service provided by the labs.
          </Text>
        </VStack>

        <VStack align="start" spacing={4}>
          <Heading size="md" color="teal.700">User Responsibility</Heading>
          <Text>
            The patients are solely responsible for maintaining the confidentiality of their own account to access information and password. The patients shall immediately notify Dilate Laboratory of any actual or suspected unauthorized use of the Users’ account or password.
          </Text>
        </VStack>

        <VStack align="start" spacing={4}>
          <Heading size="md" color="teal.700">Service Timelines</Heading>
          <Text>
            Dilate Laboratory will try to ensure that the diagnostic lab adheres to the timelines and promised services including home collection and providing test reports. However, as these are outside of our control in many cases, the liability lies with the service provider only.
          </Text>
        </VStack>

        <VStack align="start" spacing={4} bg="gray.50" p={6} borderRadius="xl" width="100%">
          <Heading size="sm">Security Note</Heading>
          <Text fontSize="sm">
            Internet is not considered a 100% secure medium and privacy cannot be fully ensured. We recommend the users to use appropriate security, antivirus, and other protective software.
          </Text>
        </VStack>
      </VStack>
    </Box>
  );
}
